import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Settings } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { URLPaths } from 'models/enums';
import Button from 'domains/core/components/Button';
import PageLayout from 'domains/core/components/PageLayout';
import SearchField from 'domains/core/components/SearchField';
import useGetRolesList from 'hooks/queries/useGetRolesList';
import RolesTable from './RolesTable';

const RolesPage = () => {
    const history = useHistory();
    const [searchTerm, setSearchTerm] = useState('');
    const { data, isLoading } = useGetRolesList({
        limit: 50,
        offset: 0,
        searchTerm: searchTerm.trim() || undefined,
    });
    const roles = data?.data ?? [];

    const headerOthers = (
        <Stack direction="row" spacing={0} alignItems="center">
            <SearchField
                placeholder="Search roles..."
                value={searchTerm}
                onChange={setSearchTerm}
                dataTestId="access-center-roles-search-input"
            />
        </Stack>
    );

    const handleCreateRole = () => {
        history.push(URLPaths.SETTINGS_ROLES_CREATE);
    };

    const headerAction = (
        <Button variant="outlined" onClick={handleCreateRole} data-testid="access-center-roles-create-role-button">
            Create Role
        </Button>
    );

    return (
        <Stack data-testid="access-center-roles-page" role="main" aria-label="Users and roles - Roles">
            <PageLayout
                header="Roles"
                headerIcon={<Settings fontSize="inherit" />}
                headerOthers={headerOthers}
                headerAction={headerAction}
            >
                <RolesTable roles={roles} isLoading={isLoading} />
            </PageLayout>
        </Stack>
    );
};

export default RolesPage;
